module.exports = __webpack_public_path__ + "img/bg08.b62245bb.gif";